import { apiGet, apiPost } from "../shared/apiClient";

export function fetchPaymentHistory(queryPk) {
  return apiGet(`/queries/${queryPk}/payments`)
    .then(res => {
      if (!res.data?.success) return null;
      const d = res.data.data ?? {};
      return { payments: d.payments ?? [], afterSales: d.after_sales ?? null };
    })
    .catch(() => null);
}

export function recordPayment(queryPk, payload) {
  return apiPost(`/queries/${queryPk}/payments`, payload).then(res => res.data);
}

export function createPaymentLink(queryPk, payload) {
  return apiPost(`/queries/${queryPk}/payments/create-link`, payload).then(res => res.data);
}

export function sendPaymentLink(paymentId, userId) {
  return apiPost(`/payments/${paymentId}/send-link`, { userId }).then(res => res.data);
}

export function markPaymentReceived(paymentId, payload) {
  return apiPost(`/payments/${paymentId}/mark-received`, payload).then(res => res.data);
}

export function cancelPaymentLink(paymentId, userId, reason) {
  return apiPost(`/payments/${paymentId}/cancel`, { userId, reason }).then(res => res.data);
}

// Locks the invoice (parts + delivery + VAT) for a query, decoupled from any
// payment method — idempotent server-side, returns the existing after-sales
// row if one's already there.
export function lockInvoice(queryPk, { userId, pricingSnapshot }) {
  return apiPost(`/queries/${queryPk}/after-sales/lock`, { userId, pricing_snapshot: pricingSnapshot }).then(res => res.data);
}

// Undoes a lock while the invoice is still financially untouched (no
// payment activity yet) — lets staff fix a locked total if the price
// changed before anyone actually paid. Backend rejects once any payment
// record exists.
export function unlockInvoice(queryPk, userId) {
  return apiPost(`/queries/${queryPk}/after-sales/unlock`, { userId }).then(res => res.data);
}

// Flags the remaining balance as Cash on Delivery — reversible, not a
// payment record — so Operations can proceed with fulfilment while the
// financial payment_status honestly stays partial.
export function setRemainderCod(queryPk, userId) {
  return apiPost(`/queries/${queryPk}/after-sales/remainder-cod`, { userId }).then(res => res.data);
}
